module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.showDialog,
      "width": "900px",
      "top": "4vh",
      "close-on-click-modal": false,
      "custom-class": "whatsapp-templates-dialog"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      },
      "close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "wtd-header",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    staticClass: "wtd-header-icon"
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "wtd-header-title"
  }, [_vm._v("Templates de Mensagem")]), _vm._v(" "), _c('div', {
    staticClass: "wtd-header-subtitle"
  }, [_vm._v(_vm._s(_vm.parent && _vm.parent.formData ? _vm.parent.formData.nome : ''))])])]), _vm._v(" "), _c('el-tabs', {
    staticClass: "wtd-tabs",
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Templates Cadastrados",
      "name": "lista"
    }
  }, [_c('div', {
    staticClass: "templates-toolbar"
  }, [(!_vm.loadingList) ? _c('span', {
    staticClass: "templates-count"
  }, [_vm._v("\n          " + _vm._s(_vm.templates.length) + " template" + _vm._s(_vm.templates.length === 1 ? '' : 's') + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "templates-toolbar-actions"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "fa fa-refresh",
      "loading": _vm.loadingList
    },
    on: {
      "click": _vm.carregarTemplates
    }
  }, [_vm._v("\n            Atualizar\n          ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "fa fa-plus"
    },
    on: {
      "click": _vm.abrirNovo
    }
  }, [_vm._v("\n            Novo Template\n          ")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingList),
      expression: "loadingList"
    }],
    staticClass: "templates-list"
  }, [(!_vm.loadingList && _vm.templates.length === 0 && !_vm.listError) ? _c('div', {
    staticClass: "templates-empty"
  }, [_c('i', {
    staticClass: "fa fa-comments-o"
  }), _vm._v(" "), _c('p', [_vm._v("Nenhum template encontrado nesta conta")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.templates), function(row) {
    return _c('div', {
      key: row.id || row.name,
      staticClass: "template-card",
      on: {
        "click": function($event) {
          return _vm.visualizarTemplate(row)
        }
      }
    }, [_c('div', {
      staticClass: "template-card-icon",
      class: 'is-' + (row.category || '').toLowerCase()
    }, [_c('i', {
      class: _vm.categoriaIcone(row.category)
    })]), _vm._v(" "), _c('div', {
      staticClass: "template-card-main"
    }, [_c('div', {
      staticClass: "template-card-name"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('div', {
      staticClass: "template-card-meta"
    }, [_vm._v("\n              " + _vm._s(_vm.categoriaLabel(row.category)) + " · " + _vm._s(_vm.idiomaLabel(row.language)) + "\n            ")])]), _vm._v(" "), _c('span', {
      staticClass: "template-status",
      class: 'is-' + (row.status || '').toLowerCase()
    }, [_c('i', {
      class: _vm.statusIcone(row.status)
    }), _vm._v("\n            " + _vm._s(_vm.statusLabel(row.status)) + "\n          ")]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-chevron-right template-card-chevron"
    })])
  })], 2), _vm._v(" "), (_vm.listError) ? _c('div', {
    staticClass: "templates-error"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" " + _vm._s(_vm.listError) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Visualizar",
      "name": "visualizar",
      "disabled": !_vm.templateSelecionado
    }
  }, [(_vm.templateSelecionado) ? _c('div', {
    staticClass: "template-preview"
  }, [_c('div', {
    staticClass: "template-preview-header"
  }, [_c('div', [_c('strong', {
    staticClass: "template-preview-name"
  }, [_vm._v(_vm._s(_vm.templateSelecionado.name))]), _vm._v(" "), _c('span', {
    staticClass: "template-status",
    class: 'is-' + (_vm.templateSelecionado.status || '').toLowerCase(),
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('i', {
    class: _vm.statusIcone(_vm.templateSelecionado.status)
  }), _vm._v("\n              " + _vm._s(_vm.statusLabel(_vm.templateSelecionado.status)) + "\n            ")])]), _vm._v(" "), _c('span', {
    staticClass: "template-preview-meta"
  }, [_vm._v("\n            " + _vm._s(_vm.categoriaLabel(_vm.templateSelecionado.category)) + " · " + _vm._s(_vm.idiomaLabel(_vm.templateSelecionado.language)) + "\n          ")])]), _vm._v(" "), (_vm.templateSelecionado.status === 'REJECTED' && _vm.templateSelecionado.rejected_reason) ? _c('div', {
    staticClass: "templates-error"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" Motivo da rejeição: " + _vm._s(_vm.templateSelecionado.rejected_reason) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "preview-stage"
  }, [_c('div', {
    staticClass: "whatsapp-bubble"
  }, _vm._l((_vm.templateSelecionado.components), function(comp, idx) {
    return _c('div', {
      key: idx,
      staticClass: "whatsapp-bubble-component"
    }, [(comp.type === 'HEADER') ? _c('div', {
      staticClass: "whatsapp-bubble-header"
    }, [(comp.format === 'TEXT') ? [_vm._v(_vm._s(comp.text))] : [_vm._v("[Cabeçalho: " + _vm._s(comp.format) + "]")]], 2) : (comp.type === 'BODY') ? _c('div', {
      staticClass: "whatsapp-bubble-body"
    }, [_vm._v(_vm._s(comp.text))]) : (comp.type === 'FOOTER') ? _c('div', {
      staticClass: "whatsapp-bubble-footer"
    }, [_vm._v(_vm._s(comp.text))]) : (comp.type === 'BUTTONS') ? _c('div', {
      staticClass: "whatsapp-bubble-buttons"
    }, _vm._l((comp.buttons), function(btn, bidx) {
      return _c('div', {
        key: bidx,
        staticClass: "whatsapp-bubble-button"
      }, [_vm._v("\n                  " + _vm._s(btn.text) + "\n                ")])
    }), 0) : _vm._e()])
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Novo Template",
      "name": "novo"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingSave),
      expression: "loadingSave"
    }],
    attrs: {
      "element-loading-text": "Enviando para aprovação da Meta..."
    }
  }, [_c('div', {
    staticClass: "novo-template-layout"
  }, [_c('div', {
    staticClass: "novo-template-form"
  }, [_c('el-form', {
    ref: "formNovo",
    attrs: {
      "label-position": "top",
      "model": _vm.novoTemplate
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('el-form-item', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                      Nome do Template\n                      "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "top",
      "content": "Apenas letras minúsculas, números e underscore. Ex: confirmacao_agendamento"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "ex: confirmacao_agendamento",
      "maxlength": "512"
    },
    on: {
      "input": _vm.normalizarNome
    },
    model: {
      value: (_vm.novoTemplate.name),
      callback: function($$v) {
        _vm.$set(_vm.novoTemplate, "name", $$v)
      },
      expression: "novoTemplate.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Idioma"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.novoTemplate.language),
      callback: function($$v) {
        _vm.$set(_vm.novoTemplate, "language", $$v)
      },
      expression: "novoTemplate.language"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Português (BR)",
      "value": "pt_BR"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Inglês (US)",
      "value": "en_US"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Espanhol",
      "value": "es"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Categoria"
    }
  }, [_c('el-radio-group', {
    staticClass: "category-radio-group",
    model: {
      value: (_vm.novoTemplate.category),
      callback: function($$v) {
        _vm.$set(_vm.novoTemplate, "category", $$v)
      },
      expression: "novoTemplate.category"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "UTILITY"
    }
  }, [_vm._v("Utilidade")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "MARKETING"
    }
  }, [_vm._v("Marketing")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "AUTHENTICATION"
    }
  }, [_vm._v("Autenticação")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cabeçalho (opcional)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Texto do cabeçalho",
      "maxlength": "60",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.novoTemplate.header),
      callback: function($$v) {
        _vm.$set(_vm.novoTemplate, "header", $$v)
      },
      expression: "novoTemplate.header"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('el-form-item', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                      Corpo da Mensagem\n                      "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "320px"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                          Use {1}, {2}, etc. para variáveis dinâmicas."), _c('br'), _vm._v("\n                          Ex: Olá {1}, seu exame está agendado para {2}.\n                        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "Ex: Olá {1}, seu exame está agendado para {2}.",
      "maxlength": "1024",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.novoTemplate.body),
      callback: function($$v) {
        _vm.$set(_vm.novoTemplate, "body", $$v)
      },
      expression: "novoTemplate.body"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Rodapé (opcional)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Texto do rodapé",
      "maxlength": "60",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.novoTemplate.footer),
      callback: function($$v) {
        _vm.$set(_vm.novoTemplate, "footer", $$v)
      },
      expression: "novoTemplate.footer"
    }
  })], 1)], 1)])]), _vm._v(" "), (_vm.saveError) ? _c('div', {
    staticClass: "templates-error"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" " + _vm._s(_vm.saveError) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "novo-template-preview"
  }, [_c('div', {
    staticClass: "template-preview-label"
  }, [_vm._v("Pré-visualização")]), _vm._v(" "), _c('div', {
    staticClass: "preview-stage preview-stage-sticky"
  }, [_c('div', {
    staticClass: "whatsapp-bubble"
  }, [(_vm.novoTemplate.header) ? _c('div', {
    staticClass: "whatsapp-bubble-header"
  }, [_vm._v(_vm._s(_vm.novoTemplate.header))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "whatsapp-bubble-body"
  }, [_vm._v(_vm._s(_vm.novoTemplate.body || 'O corpo da mensagem aparecerá aqui...'))]), _vm._v(" "), (_vm.novoTemplate.footer) ? _c('div', {
    staticClass: "whatsapp-bubble-footer"
  }, [_vm._v(_vm._s(_vm.novoTemplate.footer))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "novo-template-actions"
  }, [_c('el-button', {
    on: {
      "click": _vm.limparNovo
    }
  }, [_vm._v("Limpar")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingSave
    },
    on: {
      "click": _vm.enviarTemplate
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v(" Enviar para Aprovação da Meta\n          ")])], 1)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a110ca9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/conta-whatsapp/templates.vue
// module id = 1543
// module chunks = 45